import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { POSModeState } from 'src/common/interfaces/states/POSModeState';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';

export const initialState: POSModeState = {
  trainingMode: false,
  returnMode: { saleMode: false },
  postLoginInitialized: false,
};

class POSModeReducer extends ImmerReducer<POSModeState> {
  public setState(state: Partial<POSModeState>): void {
    this.draftState = { ...this.draftState, ...state };
  }

  public setTrainingState(active: boolean): void {
    this.draftState = { ...this.draftState, trainingMode: active };
  }

  public setPostLoginInitialized(intialized: boolean): void {
    this.draftState = { ...this.draftState, postLoginInitialized: intialized };
  }

  public setReturnState(returnType?: ReturnsType, saleMode?: boolean): void {
    this.draftState = {
      ...this.draftState,
      returnMode: { returnType, saleMode: !!saleMode },
    };
  }

  public setTBRRefundDue(refundDue: number): void {
    this.draftState = { ...this.draftState, refundDue: refundDue };
  }

  public resetState(): void {
    const isTrainingMode = this.draftState.trainingMode;
    this.draftState = initialState;
    this.draftState.trainingMode = isTrainingMode;
  }

  public toggleTrainingMode(): void {
    this.draftState.trainingMode = !this.state.trainingMode;
  }
}

export const POSModeActions = createActionCreators(POSModeReducer);
export const POSModeReducerFunction = createReducerFunction(POSModeReducer, initialState);
